import { connect } from "react-redux";
import _ from "underscore";

import SurveyCheckWord from "components/SurveyCheckWord";
import api from "api";
import storage from "utils/storage";
import { pathRole } from "utils/formatter";
import { openErrorDialog } from "redux/modules/errorDialog";
import { set, changeLocale, init } from "redux/modules/surveyCheckWord";

import data from "assets/data/QuestionData";

const mapStateToProps = state => {
  const {
    survey,
    selectedLocaleKey,
    locales,
    questions,
    additionLocales,
    choices,
    freeCommentDescriptions
  } = state.surveyCheckWord;

  // 選択した言語の設問を取得
  let newQuestion = _.filter(
    questions,
    question => question.localeKey === selectedLocaleKey
  );

  // デフォルトの設問を取得
  const defaultQuestions = data.QUESTIONS[selectedLocaleKey];

  // デフォルトから変更のあった設問をマークする
  newQuestion = _.map(newQuestion, question => {
    // デフォルトの設問
    const defaultQuestion = defaultQuestions.find(q => q.id === question.qNo);

    // 設問を比較して異なれば変更フラグを立てる
    question.changed = question.text !== defaultQuestion.content;

    return question;
  });

  // 選択した言語の属性を取得
  let newAdditionLocales = _.filter(
    additionLocales,
    additionLocale => additionLocale.localeKey === selectedLocaleKey
  );

  // 追加設問に選択肢をセットする
  newAdditionLocales = _.map(newAdditionLocales, additionLocale => {
    const additionChoices = _.filter(
      choices,
      choice => choice.additionLocaleId === additionLocale.id
    );

    // 属性に選択肢を追加
    additionLocale.choices = additionChoices;
    return additionLocale;
  });

  // 自由記入の説明を取得
  const freeCommentDescription = _.find(freeCommentDescriptions, fcd => {
    return fcd.localeKey === selectedLocaleKey;
  });

  let freeCommentDescription1 = null;
  let freeCommentDescription2 = null;
  if (freeCommentDescription) {
    freeCommentDescription1 = freeCommentDescription.description1;
    freeCommentDescription2 = freeCommentDescription.description2;
  }

  return {
    survey,
    selectedLocaleKey,
    locales,
    questions: newQuestion,
    additionLocales: newAdditionLocales,
    freeCommentDescription1,
    freeCommentDescription2
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  // 表示データ取得
  fetchSurveyWord: () => {
    const surveyId = ownProps.match.params.id;

    api
      .get(`survey_check_word/${surveyId}`)
      .then(res => {
        dispatch(
          set(
            res.survey,
            res.locales,
            res.questions,
            res.additionLocales,
            res.choices,
            res.freeCommentDescriptions
          )
        );
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  // 言語の切り替え
  changeLocale: (event, localeId) => {
    dispatch(changeLocale(localeId));
  },
  // プレビューへ移動
  moveToPreview: survey => () => {
    storage.setUrlToken(survey.surveyUrl);
    storage.setPreviewRole(pathRole());
    window.open(survey.answerPreviewUrl());
  },
  // 初期化
  init: () => dispatch(init())
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyCheckWord);



// WEBPACK FOOTER //
// ./src/containers/SurveyCheckWordContainer.js